import {IndisponibilidadeListaComponent} from './indisponibilidade-lista/indisponibilidade-lista.component';
import {AppSharedModule} from '../app-shared.module';
import {NgModule} from '@angular/core';
import {IndisponibilidadeService} from './indisponibilidade.service';
import {IndisponibilidadeRoutingModule} from './indisponibilidade.routing';
import {ComponentsModule} from '../components/components.module';
import { IndisponibilidadeFrmComponent } from './indisponibilidade-frm/indisponibilidade-frm.component';
import { IndisponibilidadeEdicaoComponent } from './indisponibilidade-edicao/indisponibilidade-edicao.component';

@NgModule({
  imports: [
    AppSharedModule,
    ComponentsModule
  ],
  declarations: [
    IndisponibilidadeListaComponent,
    IndisponibilidadeFrmComponent,
    IndisponibilidadeEdicaoComponent,
  ],
  exports: [
    IndisponibilidadeRoutingModule,
  ],
  providers: [
    IndisponibilidadeService,
  ]
})

export class IndisponibilidadeModule {}
